import { useMemo, FC } from 'react';
import { BodyText, Stack, StatusLight } from '@servicetitan/design-system';
import { PieChartProps, PiePiece } from '../utils/interface';
import { convertSessionsToPieces } from '../utils/const';
import { Pie } from './pie';
import * as Styles from './pie-chart.module.less';

const PieTitles: FC<{ title: string; pieces: PiePiece[] }> = ({ title, pieces }) => {
    return (
        <Stack className={Styles.titleWrapper}>
            <Stack.Item className={Styles.emptyPadding} />
            <Stack direction="column" justifyContent="center">
                {!!pieces.length && (
                    <Stack.Item className="p-l-1 p-b-1">
                        <BodyText bold>{title}</BodyText>
                    </Stack.Item>
                )}
                {pieces.map(piece => (
                    <Stack key={piece.title} alignItems="center">
                        <StatusLight color={piece.color} />
                        <BodyText className="c-neutral-90" size="medium">
                            {piece.title}
                        </BodyText>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export const PieChart: FC<PieChartProps> = ({ title, sections, popoverContent }) => {
    const pieces = useMemo(() => convertSessionsToPieces(sections), [sections]);

    return (
        <div className="d-f flex-row">
            <Pie title={title} pieces={pieces} popoverContent={popoverContent} />
            <PieTitles title={title} pieces={pieces} />
        </div>
    );
};
